declare global {
  interface Window {
    dataLayer: any[]
    gtag: (...args: any[]) => void
  }
}

type Currency = 'TRY' | 'USD' | 'EUR' | 'GBP'

interface Item {
  item_id: string
  item_name: string
  affiliation?: string
  coupon?: string
  discount?: number
  index?: number
  item_brand?: string
  item_category?: string
  item_category2?: string
  item_category3?: string
  item_category4?: string
  item_category5?: string
  item_list_id?: string
  item_list_name?: string
  item_variant?: string
  location_id?: string
  price: number
  quantity: number
}

interface PurchaseEvent {
  transaction_id: string
  value: number
  currency: Currency
  tax?: number
  shipping?: number
  items: Item[]
  coupon?: string
  affiliation?: string
}

export const GA4_MEASUREMENT_ID = 'G-MV1F1Z2N0H'

let initialized = false
let activeMeasurementId = ''

export const gtagService = {
  init(measurementId: string) {
    if (initialized) return
    initialized = true
    activeMeasurementId = measurementId
    window.dataLayer = window.dataLayer || []

    if (typeof window.gtag !== 'function') {
      window.gtag = function gtag() {
        window.dataLayer.push(arguments)
      }
    }

    window.gtag('js', new Date())
    window.gtag('config', measurementId)
  },

  trackEvent(eventName: string, parameters?: Record<string, any>) {
    if (typeof window.gtag !== 'function') {
      console.warn('Google Analytics not initialized')
      return
    }

    window.gtag('event', eventName, parameters)
  },

  trackPurchase(purchase: PurchaseEvent) {
    this.trackEvent('purchase', {
      transaction_id: purchase.transaction_id,
      value: purchase.value,
      currency: purchase.currency,
      tax: purchase.tax,
      shipping: purchase.shipping,
      affiliation: purchase.affiliation || 'DersKaynağı',
      items: purchase.items
    })

    this.trackConversion(purchase.value, purchase.currency, purchase.transaction_id)
  },

  trackConversion(value: number, currency: string, transactionId?: string) {
    if (typeof window.gtag !== 'function') {
      console.warn('Google Analytics not initialized')
      return
    }

    window.gtag('event', 'conversion', {
      send_to: 'AW-1029648358/sNW2CMS23e8cEObf_OoD',
      value: value,
      currency: currency,
      transaction_id: transactionId
    })
  },

  trackBeginCheckout(items: Item[], value: number, currency: Currency) {
    this.trackEvent('begin_checkout', {
      value,
      currency,
      items
    })
  },

  trackAddToCart(items: Item[], value: number, currency: Currency) {
    this.trackEvent('add_to_cart', {
      value,
      currency,
      items
    })
  },

  trackViewCart(items: Item[], value: number, currency: Currency) {
    this.trackEvent('view_cart', {
      value,
      currency,
      items
    })
  },

  trackViewItem(items: Item[], value: number, currency: Currency) {
    this.trackEvent('view_item', {
      value,
      currency,
      items
    })
  },

  trackPageView(pageTitle: string, pageLocation: string) {
    if (typeof window.gtag !== 'function') {
      console.warn('Google Analytics not initialized')
      return
    }

    window.gtag('event', 'page_view', {
      page_title: pageTitle,
      page_location: pageLocation,
      send_to: activeMeasurementId || GA4_MEASUREMENT_ID
    })
  },

  trackSignUp(method: string) {
    this.trackEvent('sign_up', {
      method
    })
  },

  trackLogin(method: string) {
    this.trackEvent('login', {
      method
    })
  },

  trackGenerateLead(formId: string, value?: number) {
    this.trackEvent('generate_lead', {
      form_id: formId,
      value
    })
  }
}
